import { Checkbox, Text } from '@vidahealth/vida-ui';

import { CheckboxCheckIndicator } from '@/modules/ui';

type CheckboxCardContentProps = {
  label: string;
  isSelected: boolean;
};

// Content for a SelectableRow used as a checkbox option: a visual-only
// checkbox indicator (`pointerEvents='none'` — the card row handles the tap)
// plus a bold label.
export function CheckboxCardContent({ label, isSelected }: CheckboxCardContentProps) {
  return (
    <>
      <Checkbox value={label} isChecked={isSelected} pointerEvents='none'>
        <CheckboxCheckIndicator />
      </Checkbox>
      <Text size='md' weight='semibold' className='flex-1 text-typography-900'>
        {label}
      </Text>
    </>
  );
}
